import React from 'react';
import { HeartIcon, BookIcon, HomeIcon, UsersIcon, ShieldIcon, HeartHandshakeIcon } from 'lucide-react';
export function EngagedPreparation() {
  return <div className="max-w-4xl mx-auto" data-id="element-1854">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center text-purple-900" data-id="element-1855">
        الاستعداد للحياة الزوجية
      </h2>
      <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-1856">
        <div className="flex items-center mb-4" data-id="element-1857">
          <HeartIcon className="h-8 w-8 text-purple-600 ml-4" data-id="element-1858" />
          <h3 className="text-xl font-bold text-purple-800" data-id="element-1859">
            أهمية التحضير للزواج
          </h3>
        </div>
        <p className="text-slate-700 leading-relaxed mb-4" data-id="element-1860">
          الزواج في الإسلام ليس مجرد علاقة عابرة، بل هو ميثاق غليظ وعهد مقدس.
          والإعداد الجيد للزواج يساعد في بناء أسرة مستقرة وسعيدة. قال تعالى:
          "وَمِنْ آيَاتِهِ أَنْ خَلَقَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَاجًا
          لِّتَسْكُنُوا إِلَيْهَا وَجَعَلَ بَيْنَكُم مَّوَدَّةً وَرَحْمَةً".
        </p>
        <div className="p-4 bg-purple-50 rounded-lg border border-purple-100" data-id="element-1861">
          <p className="text-purple-800 text-sm" data-id="element-1862">
            <span className="font-bold" data-id="element-1863">نصيحة: </span>
            استثمر وقتاً كافياً في فترة الخطوبة للتعرف على الطرف الآخر ضمن
            الضوابط الشرعية، وتعلم المزيد عن حقوق وواجبات الزوجين.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1864">
        <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-purple-500" data-id="element-1865">
          <div className="flex items-center mb-4" data-id="element-1866">
            <BookIcon className="h-6 w-6 text-purple-600 ml-3" data-id="element-1867" />
            <h3 className="font-bold text-lg text-purple-800" data-id="element-1868">
              التثقيف الشرعي
            </h3>
          </div>
          <ul className="space-y-2" data-id="element-1869">
            <li className="flex items-start" data-id="element-1870">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-1871"></span>
              <span className="text-slate-700" data-id="element-1872">
                تعلم أحكام الزواج في الإسلام
              </span>
            </li>
            <li className="flex items-start" data-id="element-1873">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-1874"></span>
              <span className="text-slate-700" data-id="element-1875">فهم مقاصد الزواج وأهدافه</span>
            </li>
            <li className="flex items-start" data-id="element-1876">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-1877"></span>
              <span className="text-slate-700" data-id="element-1878">معرفة آداب الحياة الزوجية</span>
            </li>
            <li className="flex items-start" data-id="element-1879">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-1880"></span>
              <span className="text-slate-700" data-id="element-1881">حضور دورات تأهيلية للزواج</span>
            </li>
          </ul>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-sky-500" data-id="element-1882">
          <div className="flex items-center mb-4" data-id="element-1883">
            <HeartHandshakeIcon className="h-6 w-6 text-sky-600 ml-3" data-id="element-1884" />
            <h3 className="font-bold text-lg text-sky-800" data-id="element-1885">التواصل الفعال</h3>
          </div>
          <ul className="space-y-2" data-id="element-1886">
            <li className="flex items-start" data-id="element-1887">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-1888"></span>
              <span className="text-slate-700" data-id="element-1889">تعلم مهارات الاستماع الجيد</span>
            </li>
            <li className="flex items-start" data-id="element-1890">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-1891"></span>
              <span className="text-slate-700" data-id="element-1892">
                التعبير عن المشاعر بشكل صحي
              </span>
            </li>
            <li className="flex items-start" data-id="element-1893">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-1894"></span>
              <span className="text-slate-700" data-id="element-1895">مناقشة التوقعات المستقبلية</span>
            </li>
            <li className="flex items-start" data-id="element-1896">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-sky-500 mt-2" data-id="element-1897"></span>
              <span className="text-slate-700" data-id="element-1898">
                تعلم حل الخلافات بطرق إيجابية
              </span>
            </li>
          </ul>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-rose-500" data-id="element-1899">
          <div className="flex items-center mb-4" data-id="element-1900">
            <HomeIcon className="h-6 w-6 text-rose-600 ml-3" data-id="element-1901" />
            <h3 className="font-bold text-lg text-rose-800" data-id="element-1902">التخطيط المالي</h3>
          </div>
          <ul className="space-y-2" data-id="element-1903">
            <li className="flex items-start" data-id="element-1904">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-1905"></span>
              <span className="text-slate-700" data-id="element-1906">وضع ميزانية مشتركة</span>
            </li>
            <li className="flex items-start" data-id="element-1907">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-1908"></span>
              <span className="text-slate-700" data-id="element-1909">تحديد أولويات الإنفاق</span>
            </li>
            <li className="flex items-start" data-id="element-1910">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-1911"></span>
              <span className="text-slate-700" data-id="element-1912">
                فهم المسؤوليات المالية لكل طرف
              </span>
            </li>
            <li className="flex items-start" data-id="element-1913">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-rose-500 mt-2" data-id="element-1914"></span>
              <span className="text-slate-700" data-id="element-1915">
                الاتفاق على طريقة إدارة الأموال
              </span>
            </li>
          </ul>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-amber-500" data-id="element-1916">
          <div className="flex items-center mb-4" data-id="element-1917">
            <UsersIcon className="h-6 w-6 text-amber-600 ml-3" data-id="element-1918" />
            <h3 className="font-bold text-lg text-amber-800" data-id="element-1919">
              العلاقات الأسرية
            </h3>
          </div>
          <ul className="space-y-2" data-id="element-1920">
            <li className="flex items-start" data-id="element-1921">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-1922"></span>
              <span className="text-slate-700" data-id="element-1923">تحديد شكل العلاقة مع الأهل</span>
            </li>
            <li className="flex items-start" data-id="element-1924">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-1925"></span>
              <span className="text-slate-700" data-id="element-1926">وضع حدود صحية مع العائلتين</span>
            </li>
            <li className="flex items-start" data-id="element-1927">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-1928"></span>
              <span className="text-slate-700" data-id="element-1929">
                التعرف على عائلة الطرف الآخر
              </span>
            </li>
            <li className="flex items-start" data-id="element-1930">
              <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-amber-500 mt-2" data-id="element-1931"></span>
              <span className="text-slate-700" data-id="element-1932">
                تعلم فن التعامل مع أهل الزوج/الزوجة
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-1933">
        <div className="flex items-center mb-4" data-id="element-1934">
          <ShieldIcon className="h-8 w-8 text-green-600 ml-4" data-id="element-1935" />
          <h3 className="text-xl font-bold text-green-800" data-id="element-1936">
            الشروط والحقوق في عقد الزواج
          </h3>
        </div>
        <p className="text-slate-700 leading-relaxed mb-4" data-id="element-1937">
          من المهم فهم أن عقد الزواج في الإسلام يمكن أن يتضمن شروطاً مشروعة يتفق
          عليها الطرفان. قال النبي ﷺ: "إن أحق الشروط أن توفوا به ما استحللتم به
          الفروج".
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1938">
          <div className="bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-1939">
            <h4 className="font-bold text-green-800 mb-2" data-id="element-1940">
              من حق المرأة أن تشترط:
            </h4>
            <ul className="space-y-1" data-id="element-1941">
              <li className="flex items-start" data-id="element-1942">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-green-500 mt-2" data-id="element-1943"></span>
                <span className="text-slate-700" data-id="element-1944">إكمال دراستها</span>
              </li>
              <li className="flex items-start" data-id="element-1945">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-green-500 mt-2" data-id="element-1946"></span>
                <span className="text-slate-700" data-id="element-1947">العمل في مجال تخصصها</span>
              </li>
              <li className="flex items-start" data-id="element-1948">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-green-500 mt-2" data-id="element-1949"></span>
                <span className="text-slate-700" data-id="element-1950">سكن مستقل عن أهل الزوج</span>
              </li>
              <li className="flex items-start" data-id="element-1951">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-green-500 mt-2" data-id="element-1952"></span>
                <span className="text-slate-700" data-id="element-1953">
                  عدم السفر بها بعيداً عن أهلها
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-1954">
            <h4 className="font-bold text-blue-800 mb-2" data-id="element-1955">
              من حق الرجل أن يشترط:
            </h4>
            <ul className="space-y-1" data-id="element-1956">
              <li className="flex items-start" data-id="element-1957">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-blue-500 mt-2" data-id="element-1958"></span>
                <span className="text-slate-700" data-id="element-1959">
                  عدم عمل الزوجة في مكان معين
                </span>
              </li>
              <li className="flex items-start" data-id="element-1960">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-blue-500 mt-2" data-id="element-1961"></span>
                <span className="text-slate-700" data-id="element-1962">
                  المشاركة في نفقات البيت إن كانت موظفة
                </span>
              </li>
              <li className="flex items-start" data-id="element-1963">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-blue-500 mt-2" data-id="element-1964"></span>
                <span className="text-slate-700" data-id="element-1965">
                  تحديد عدد مرات زيارة الأهل
                </span>
              </li>
              <li className="flex items-start" data-id="element-1966">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-blue-500 mt-2" data-id="element-1967"></span>
                <span className="text-slate-700" data-id="element-1968">الإقامة في مدينة معينة</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="p-4 bg-amber-50 rounded-lg border border-amber-100" data-id="element-1969">
          <p className="text-amber-800 text-sm" data-id="element-1970">
            <span className="font-bold" data-id="element-1971">ملاحظة هامة: </span>
            الشروط في عقد الزواج ملزمة إذا كانت موافقة للشرع ووافق عليها
            الطرفان. وينبغي مناقشتها بصراحة قبل العقد لتجنب المشاكل المستقبلية.
          </p>
        </div>
      </div>
      <div className="bg-purple-700 text-white rounded-lg shadow-md p-6" data-id="element-1972">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-1973">
          نصائح ذهبية للمقبلين على الزواج
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1974">
          <div className="bg-purple-800 bg-opacity-50 p-4 rounded-lg" data-id="element-1975">
            <p className="mb-2 font-bold" data-id="element-1976">الصدق والوضوح منذ البداية</p>
            <p className="text-purple-100 text-sm" data-id="element-1977">
              تجنب إخفاء الحقائق المهمة عن شريك حياتك المستقبلي، وكن واضحاً بشأن
              توقعاتك وأهدافك.
            </p>
          </div>
          <div className="bg-purple-800 bg-opacity-50 p-4 rounded-lg" data-id="element-1978">
            <p className="mb-2 font-bold" data-id="element-1979">تعلم فن التنازل</p>
            <p className="text-purple-100 text-sm" data-id="element-1980">
              الحياة الزوجية تقوم على التنازلات المتبادلة، فتعلم متى تتنازل ومتى
              تتمسك برأيك.
            </p>
          </div>
          <div className="bg-purple-800 bg-opacity-50 p-4 rounded-lg" data-id="element-1981">
            <p className="mb-2 font-bold" data-id="element-1982">الاستعداد النفسي</p>
            <p className="text-purple-100 text-sm" data-id="element-1983">
              الزواج مسؤولية كبيرة تتطلب استعداداً نفسياً للانتقال من حياة
              العزوبية إلى حياة الشراكة.
            </p>
          </div>
          <div className="bg-purple-800 bg-opacity-50 p-4 rounded-lg" data-id="element-1984">
            <p className="mb-2 font-bold" data-id="element-1985">التعلم المستمر</p>
            <p className="text-purple-100 text-sm" data-id="element-1986">
              اقرأ عن الحياة الزوجية الناجحة، وتعلم من تجارب الآخرين، واحضر
              دورات تأهيلية للزواج.
            </p>
          </div>
        </div>
      </div>
    </div>;
}